<router-outlet></router-outlet>

<div class="privacy-container" *ngIf="!privacy">
    <button mat-button type="button">
        <a [href]="privacyLink" target="_blank">Datenschutzhinweise</a>
    </button>
</div>